export const STORAGE_KEY = 'basketStorage'

export const basketState = {
  // item is object model like this { product, quantity }
  basketItems: JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]')
}

export const basketGetters = {
  getBasketItems: state => state.basketItems
}

export const basketMutations = {
  addOrEditItem (state, { product, quantity }) {
    const result = state.basketItems.filter(item => item.product._id == product._id);

    if (result == 0) {
      // state.basketItems.push({
      //   product,
      //   quantity
      // })
       state.basketItems[0] = {
        product,
        quantity
      }
    } else {
      // set new value
      result[0].quantity = quantity
    }
  },

  changeQuantity (state, { productItem }) {
    state.basketItems[state.basketItems.indexOf(productItem)].quantity = productItem.quantity
  },

  removeItem (state, { productItem }) {
    state.basketItems.splice(state.basketItems.indexOf(productItem), 1)
  },

  clearItems (state) {
    state.basketItems = []
  },
}

export const basketPlugins = store => {
  store.subscribe((basket, { basketItems }) => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(basketItems))
  })
}


// WEBPACK FOOTER //
// ./src/store/basket.js